import { Component, EventEmitter, Input, OnChanges, Output, signal, SimpleChanges, WritableSignal } from '@angular/core';
import { RibbonStyles } from 'src/app/models/constants/store-services.constant';
import { RibbonColor } from 'src/app/models/enums/Ribbon.enum';
import { Ribbon } from 'src/app/models/types/Ribbon.type';
import { SharedModule } from 'src/app/modules/shared.module';

@Component({
  selector: 'app-ribbon-bento-view',
  imports: [SharedModule],
  templateUrl: './ribbon-bento-view.component.html',
  styleUrl: './ribbon-bento-view.component.scss'
})
export class RibbonBentoViewComponent implements OnChanges {

  public ribbonList = Array.from(RibbonStyles.values());

  @Input() ribbon: Ribbon = this.ribbonList[0];

  @Output() handleClick = new EventEmitter<RibbonColor>();


  public loading: WritableSignal<boolean> = signal(true);
  public currentRibbon: WritableSignal<Ribbon> = signal(this.ribbon);

  ngOnChanges(changes: SimpleChanges): void {
    this.setCurrentRibbon(changes["ribbon"].currentValue);
  }

  setCurrentRibbon(ribbon: Ribbon) {
    this.loading.set(true);
      setTimeout(() => {
        this.loading.set(false);
        this.currentRibbon.set(ribbon);
      }, 500);
  }

}
